import { render } from "./ResourceLoadingIndicator.vue?vue&type=template&id=81322232&scoped=true"
import script from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js"
export * from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js"

import "./ResourceLoadingIndicator.vue?vue&type=style&index=0&id=81322232&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81322232"]])

export default __exports__